"use strict";
exports.__esModule = true;
exports.isMobile = exports.getScreenWidth = void 0;
var design_language_1 = require("@doordash/design-language");
exports.getScreenWidth = function () {
    if (typeof window === 'undefined') {
        return design_language_1.Breakpoints.Mobile;
    }
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
};
exports.isMobile = function () { return exports.getScreenWidth() < design_language_1.Breakpoints.Desktop; };
